<script lang="ts">
	import CloseOutline from '$lib/assets/images/icons/close-outline.svg?component';
	import Success from '$lib/components/Global/Success.svelte';
	import __ from '$lib/stores/TranslationStore';
	import { createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
	import { twMerge } from 'tailwind-merge';

	let className: string = '';
	export { className as class };

	const dispatch = createEventDispatcher();
</script>

<div
	transition:fade
	class={twMerge(
		'fixed z-[20] left-0 top-0 z-40 flex h-screen w-full flex-col items-center justify-center bg-slate-inactive bg-opacity-10 backdrop-blur-sm',
		className
	)}
>
	<Success
		class="relative left-auto right-auto z-50 mb-[20dvh] h-auto w-auto rounded-xl bg-white px-20 py-8 drop-shadow-xl"
		successText={$__('Será contactado por um agente')}
	>
		<div slot="caption" let:text>
			<button class="absolute right-2 top-2 cursor-pointer" on:click={() => dispatch('close')}>
				<CloseOutline class="h-10 scale-75" />
			</button>
			<p class="text-sm">{text}</p>
		</div>
	</Success>
</div>
